window.addEventListener('cloudlift.upload.ready', function(e) {
  const params = new URLSearchParams(window.location.search);
  const groesse = params.get("groesse");

  if (groesse) {
    // Checked Radio-Button finden und Value überschreiben
    const activeRadio = document.querySelector('input[name="swgrosse-in-cm"]:checked');
    if (activeRadio) {
      const formatted = groesse.replace(/x/gi, ' x ');
      activeRadio.value = formatted;

      // Text ins Kundenbemerkung-Feld schreiben
      const bemerkung = document.getElementById("kundenbemerkung");
      if (bemerkung) {
        bemerkung.value = "Individuelle Motivgröße (Breite x Höhe) " + groesse.replace(/x/gi, ' x ') + " cm";
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Überprüfen, ob das Hauptinhalt-Element die Klasse "collection" enthält
  const mainContent = document.querySelector(".main-content.collection");

  if (mainContent) {
    function updateFilterButtonText() {
      const filterButton = document.querySelector(".btn.btn-filter");
      const link = document.querySelector(".widget-content a.btn-link");
      const filtersToolbar = document.querySelector(".filters-toolbar");
      const existingFilter = document.querySelector(".filter-is-active");

      if (filterButton && link && filtersToolbar) {
        if (link.href !== "#") {
          filterButton.textContent = "Es ist ein Filter aktiv";

          if (!existingFilter) {
            const alertDiv = `
              <div class="filter-is-active" style="padding: 10px; margin: 0 0 20px; border: 3px solid #000; text-align: center;">
                <p>Achtung: Es ist ein Filter aktiv! Hier <a class="btn-filter" href="#">ändern</a> oder alle Filter <a class="btn-filter" href="*">entfernen</a>!</p>
              </div>`;
            filtersToolbar.insertAdjacentHTML("afterend", alertDiv);
          }
        } else {
          filterButton.textContent = "Filter";

          if (existingFilter) {
            existingFilter.remove();
          }
        }
      }
    }

    // Initiale Überprüfung bei Laden der Seite
    updateFilterButtonText();

    // Event-Listener für Klicks auf der gesamten Seite
    document.body.addEventListener("click", function () {
      updateFilterButtonText();
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Create new elements
  var newDiv = document.createElement("div");
  newDiv.className = "swatch-element";

  var newInput = document.createElement("input");
  newInput.className = "swatchInput dn";
  newInput.type = "radio";

  var newLabel = document.createElement("label");
  newLabel.className = "swatchLbl";
  newLabel.innerText = "Sondergröße";
  newLabel.style.cursor = "pointer"; // Add the cursor pointer style

  // Create anchor element
  var anchor = document.createElement("a");
  anchor.href = "#productInquiry"; // Set the href attribute to the desired link
  anchor.setAttribute("data-effect", "mfp-zoom-in");
  anchor.className = "mfp inLink";
  anchor.appendChild(newLabel); // Append the label to the anchor

  // Append new elements
  newDiv.appendChild(newInput);
  newDiv.appendChild(anchor); // Append the anchor (with the label inside) to the newDiv

  // Find the label containing "Wunschgröße in cm:"
  var labels = document.querySelectorAll("label.header");
  labels.forEach(function (label) {
    if (label.textContent.includes("Wunschgröße in cm:")) {
      // Get the parent div of the label
      var parentDiv = label.closest("div.swatch");

      if (parentDiv) {
        // Find the first swatch-element with data-value attribute
        var firstDataValueDiv = parentDiv.querySelector("div[data-value]");
        if (firstDataValueDiv) {
          // Set the data-value of the new div to match the first entry
          newDiv.setAttribute(
            "data-value",
            firstDataValueDiv.getAttribute("data-value")
          );
        }

        // Append the new div to the parent div
        parentDiv.appendChild(newDiv);
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    // Alle Elemente mit class 'cl-prop' finden
    const props = document.querySelectorAll("span.cl-prop");

    props.forEach((prop) => {
      if (prop.innerText.includes("Bildausschnitt:")) {
        const aTag = prop.querySelector("a");
        if (aTag && aTag.href) {
          const href = aTag.href;
          // Erstellen eines neuen img-Tags
          const imgTag = document.createElement("img");
          imgTag.src = href;
          imgTag.alt = "Bildausschnitt";
          imgTag.style.cursor = "pointer"; // Beibehaltung des Cursors
          imgTag.style.border = "0"; // Beibehaltung des Rahmens
          imgTag.width = 100; // Setzen der Bildbreite auf 150px

          // Einfügen eines <br> Tags nach dem Text "Bildausschnitt:"
          const brTag = document.createElement("br");

          // Einfügen des br-Tags und des img-Tags in das a-Tag
          prop.innerHTML = "Bildausschnitt:"; // Setzen des Textes ohne a-Tag
          prop.appendChild(brTag);
          prop.appendChild(aTag);
          aTag.innerHTML = "";
          aTag.appendChild(imgTag);
        }
      }
    });
  }, 500); // 500ms Verzögerung
});

document.addEventListener("DOMContentLoaded", function() {
    const getParameterByName = name => new URLSearchParams(window.location.search).get(name);

    // Holen des 'filter' und 'q' Eingabefelds
    const filterInput = document.querySelector('input[name="filter"]');
    const qInput = document.querySelector('input[name="q"]');

    // Setze den 'filter' Wert aus der URL
    const filterValue = getParameterByName('filter');
    if (filterInput && filterValue) {
        filterInput.value = filterValue;  // Setze den Wert des Filters aus der URL ins Input-Feld
    }

    // Funktion zum Aktualisieren des q-Felds und der URL
    function updateFilter() {
        // Holen des aktuellen 'product' und 'format' Werts
        const product = document.querySelector('input[name="product"]:checked').value || '';
        const format = document.querySelector('input[name="format"]:checked').value || '';

        // Kombiniere die Eingabe aus 'filter' mit 'product' und 'format'
        const combinedValue = `${filterInput.value} ${product} ${format}`;
        qInput.value = combinedValue;

        // Aktualisiere die URL mit dem neuen Wert
        const url = new URL(window.location.href);
        url.searchParams.set('filter', filterInput.value);  // Setze den 'filter'-Parameter in der URL
        window.history.replaceState({}, '', url);  // Ändere die URL, ohne die Seite neu zu laden
    }

    if (filterInput) {
        // Event-Listener für das 'input'-Feld, um die Eingabe an das 'q'-Feld zu senden
        filterInput.addEventListener('input', updateFilter);
    }

    // Event-Listener für die 'product' und 'format' Radiobuttons, um Änderungen zu erfassen
    document.querySelectorAll('input[name="product"]').forEach(radio => {
        radio.addEventListener('change', updateFilter);
    });
    document.querySelectorAll('input[name="format"]').forEach(radio => {
        radio.addEventListener('change', updateFilter);
    });

    // Setze die 'product' und 'format' Radiobuttons basierend auf den URL-Parametern
    const product = getParameterByName('product') || '';
    const format = getParameterByName('format') || '';
    document.querySelector(`input[name="product"][value="${product}"]`).checked = true;
    document.querySelector(`input[name="format"][value="${format}"]`).checked = true;
});